import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notauthorized',
  templateUrl: './notauthorized.component.html',
  styleUrls: ['./notauthorized.component.scss']
})
export class NotauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
